import { Pipe, PipeTransform } from '@angular/core';
import { getNestedValue } from '@common/classes/path-utils';

@Pipe({
    name: 'objectPath'
})
export class ObjectPathPipe implements PipeTransform {
    transform(obj: any, path: string): any {
        return getNestedValue(obj, path);
    }
}
